/**
 * Players page PDF export: options popup + download for every mode
 * (ALL, Category wise, Team wise, Top Players, Player wise, Owners).
 *
 * All photos and logos are loaded and validated here before drawing starts,
 * so the PDF never gets blank images or fails half way because of one image.
 */
import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import * as IMG from "../../../constants/Images";
import {
  createPdfImageLoader,
  loadStaticAssets,
  runWithConcurrency,
} from "./pdfImageUtils";
import { createPlayersPdfDrawers } from "./playersPdfDrawing";

const { pdflayout1, pdflayout2 } = IMG;

const STATIC_PDF_ASSETS = {
  auctiondefaultLogo: IMG.auctiondefaultLogo,
  bgtop1: IMG.bgtop1,
  pdfauctiontitlebg: IMG.pdfauctiontitlebg,
  pdfbg: IMG.pdfbg,
  playerdefaultLogo: IMG.playerdefaultLogo,
  plbg: IMG.plbg,
  rankbadge: IMG.rankbadge,
  ribbin: IMG.ribbin,
  ribbin3: IMG.ribbin3,
  tagbadge: IMG.tagbadge,
  teamdefaultLogo: IMG.teamdefaultLogo,
  tele: IMG.tele,
  topborderirng: IMG.topborderirng,
  toplprofile: IMG.toplprofile,
  whitebg: IMG.whitebg,
};

const IMAGE_CONCURRENCY = 6;

const getPlayerImgUrl = (path, img) => {
  if (!img || img === "") return "";
  if (img.startsWith("http://") || img.startsWith("https://") || img.startsWith("data:")) return img;
  return (path || "") + img;
};

const progressBoxStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  padding: "20px",
  background: "rgba(0,0,0,0.8)",
  color: "white",
  borderRadius: "8px",
  zIndex: 10000,
  fontSize: "16px",
  fontWeight: "bold",
};

export default function PlayersPdfExport({
  open,
  onClose,
  data,
  pldata,
  dataTeam,
  catdata,
  currentauc,
  aucdata,
  aucdate,
  aucminbid,
  acname,
  aid,
  auctionLogoUrl,
  teamPath,
  aucmoredetail,
  fetchTeamData,
  fetchcatData,
  getcatpageData,
}) {
  const [orderby, setorderby] = useState("");
  const [orderby2, setorderby2] = useState("");
  const [colno, setcolno] = useState("");
  const [numofpl, setnumofpl] = useState("");
  const [sts, setsts] = useState("");
  const [issetdata, setissetdata] = useState(false);
  const [isplnoshow, setisplnoshow] = useState(true);
  const [ismobnoshow, setismobnoshow] = useState(false);
  const [istshirtshow, setistshirtshow] = useState(false);
  const [isfathershow, setisfathershow] = useState(false);
  const [ispointsshow, setispointsshow] = useState(true);
  const [isdetailshow, setisdetailshow] = useState(false);
  const [isbasePriceShow, setisbasePriceShow] = useState(false);
  const [iscatshow, setiscatshow] = useState(true);
  const [isownershow, setisownershow] = useState(false);
  const [isvalshow, setisvalshow] = useState(true);
  const [isspec1, setisspec1] = useState(true);
  const [isspec2, setisspec2] = useState(true);
  const [isspec3, setisspec3] = useState(true);
  const [isspnshow, setisspnshow] = useState(false);
  const [topnum, settopnum] = useState(5);
  const [toptype, settoptype] = useState("0");
  const [ignoretype, setignoretype] = useState("");
  const [ignorecat, setignorecat] = useState("");
  const [ignoretag, setignoretag] = useState("");
  const [ignoreplnos, setignoreplnos] = useState("");
  const [pdflayouttype, setpdflayouttype] = useState("");
  const [toppltype, settoppltype] = useState("");
  const [isvicecaptaintagselect, setisvicecaptaintagselect] = useState(true);
  const [isownertagselect, setisownertagselect] = useState(true);
  const [iscoownertagselect, setiscoownertagselect] = useState(true);
  const [iscaptaintagselect, setiscaptaintagselect] = useState(true);
  const [isicontagselect, setisicontagselect] = useState(true);
  const [isretaintagselect, setisretaintagselect] = useState(true);
  const [generatecatid, setgeneratecatid] = useState("");
  const [isnocatshow, setisnocatshow] = useState(false);

  const [isGenerating, setIsGenerating] = useState(false);
  const [progress, setProgress] = useState(null);

  const loaderRef = useRef(null);
  if (!loaderRef.current) loaderRef.current = createPdfImageLoader();
  const staticAssetsRef = useRef(null);

  function setdata() {
    setissetdata((prev) => !prev);
  }

  function handleClose() {
    if (isGenerating) return;
    onClose();
  }

  const sponsorLogoUrl =
    aucmoredetail?.spn?.length > 0 && aucmoredetail.spn[0].logo
      ? aucmoredetail.spath + aucmoredetail.spn[0].logo
      : "";
  const customBgUrl =
    aucmoredetail?.more?.length > 0 && aucmoredetail.more[0].pdfbg
      ? aucmoredetail.fpath + aucmoredetail.more[0].pdfbg
      : "";

  const prepareImages = async () => {
    const loader = loaderRef.current;
    if (!staticAssetsRef.current) {
      staticAssetsRef.current = await loadStaticAssets(STATIC_PDF_ASSETS);
    }
    const assets = staticAssetsRef.current;

    const playerUrls = new Map();
    [pldata, data].forEach((source) => {
      (source?.list || []).forEach((player) => {
        const url = getPlayerImgUrl(source?.path, player.img);
        if (url) playerUrls.set(String(player.pid), url);
      });
    });

    const tasks = [];
    const header = {};
    const teamLogos = {};
    const photos = {};

    if (auctionLogoUrl) {
      tasks.push(async () => {
        header[0] = await loader.loadLogo(auctionLogoUrl);
      });
    }
    if (sponsorLogoUrl) {
      tasks.push(async () => {
        header[1] = await loader.loadLogo(sponsorLogoUrl);
      });
    }
    if (customBgUrl) {
      tasks.push(async () => {
        header[2] = await loader.loadBackground(customBgUrl);
      });
    }
    (Array.isArray(dataTeam) ? dataTeam : []).forEach((team) => {
      if (!team?.logo) return;
      tasks.push(async () => {
        teamLogos[team.tid] = await loader.loadLogo((teamPath || "") + team.logo);
      });
    });
    playerUrls.forEach((url, pid) => {
      tasks.push(async () => {
        photos[pid] = await loader.loadPlayerPhoto(url);
      });
    });

    await runWithConcurrency(
      tasks,
      (task) => task(),
      IMAGE_CONCURRENCY,
      (p) => setProgress(Math.round(p * 100))
    );

    // Same layout as before: [0] auction logo, [1] sponsor, [2] custom bg, [tid] team logo
    const aucteambase64 = [];
    Object.entries(teamLogos).forEach(([tid, logo]) => {
      if (logo) aucteambase64[tid] = logo;
    });
    [0, 1, 2].forEach((i) => {
      if (header[i]) aucteambase64[i] = header[i];
    });

    const playerImages = {};
    const roundImages = {};
    [pldata, data].forEach((source) => {
      (source?.list || []).forEach((player) => {
        const key = String(player.pid);
        const photo = photos[key];
        playerImages[key] = photo?.regular || assets.playerdefaultLogo;
        roundImages[key] = photo?.round || assets.playerdefaultLogo;
      });
    });

    return { assets, aucteambase64, playerImages, roundImages };
  };

  const handleDownload = async () => {
    if (isGenerating) return;
    if (!data?.list?.length) {
      toast.error("No players to export", { theme: "colored", position: "bottom-center" });
      return;
    }
    setIsGenerating(true);
    setProgress(0);
    try {
      const { assets, aucteambase64, playerImages, roundImages } = await prepareImages();
      setProgress(100);
      // let the 100% message paint before the (synchronous) drawing starts
      await new Promise((resolve) => setTimeout(resolve, 50));

      const drawers = createPlayersPdfDrawers({
        acname: acname || "",
        aid,
        aucdata,
        aucdate,
        aucminbid,
        aucteambase64,
        catdata,
        colno,
        currentauc,
        data,
        dataTeam,
        fetchTeamData,
        fetchcatData,
        fontcolor: localStorage.getItem("pdffont"),
        generatecatid,
        getcatpageData,
        ignorecat,
        ignoreplnos,
        ignoretag,
        ignoretype,
        isbasePriceShow,
        iscaptaintagselect,
        iscatshow,
        iscoownertagselect,
        isdetailshow,
        isfathershow,
        isicontagselect,
        ismobnoshow,
        isnocatshow,
        isownershow,
        isownertagselect,
        ispdfwhitebg: localStorage.getItem("ispdfwhitebg"),
        isplnoshow,
        isretaintagselect,
        isspec1,
        isspec2,
        isspec3,
        isspnshow,
        istshirtshow,
        isvalshow,
        isvicecaptaintagselect,
        numofpl,
        orderby,
        orderby2,
        pdflayouttype,
        playerImagesBase64: playerImages,
        playerImagesBase64Ref: { current: playerImages },
        pldata,
        roundbase64Images: roundImages,
        setpdfclk: (value) => {
          if (!value) onClose();
        },
        sts,
        topnum,
        toppltype,
        toptype,
        assets,
      });

      if (orderby2 == "6") {
        drawers.tagwisedownload();
      } else if (orderby2 == "4") {
        drawers.toppdfdownload();
      } else if (orderby2 == "5") {
        drawers.plwisepdf();
      } else {
        drawers.pdfdownload();
      }
    } catch (error) {
      console.error("Players PDF export failed:", error);
      toast.error("PDF could not be generated. Please try again.", {
        theme: "colored",
        position: "bottom-center",
      });
    } finally {
      setIsGenerating(false);
      setProgress(null);
    }
  };

  if (!open) return null;

  return (
    <>
      {progress !== null && (
        <div style={progressBoxStyle}>Loading player images: {progress}%</div>
      )}
      <>
        <div className="pdfdiv" onClick={handleClose}></div>
        <div className="pdfpopup">
          {/* <FontAwesomeIcon className="pdfclose" onClick={handleClose} icon={faXmark} /> */}
          <div>
            <div className="pdoptline1">
              <div className="pdopt1">
                <select
                  class="form-select"
                  value={orderby2}
                  onChange={(e) => {
                    setorderby2(e.target.value);
                  }}
                  aria-label="Default select example"
                >
                  <option selected hidden default disabled value="">
                    Page Record
                  </option>
                  <option value="1">ALL</option>
                  <option value="2">Category wise</option>
                  <option value="3">Team wise</option>
                  <option value="4">Top Players</option>
                  <option value="5">Player wise</option>
                  <option value="6">Owners</option>
                </select>
              </div>

              {orderby2 == "2" && (
                <div className="popt3">
                  <select
                    class="form-select"
                    value={generatecatid}
                    onChange={(e) => {
                      setgeneratecatid(e.target.value);
                    }}
                    aria-label="Default select example"
                  >
                    <option selected default value="">
                      Select Category
                    </option>
                    {catdata &&
                      catdata?.map((cat) => {
                        return <option value={cat.cid}>{cat.cname}</option>;
                      })}
                    <option value="0">No category</option>
                  </select>
                </div>
              )}
              {orderby2 == "4" && (
                <div className="popt3">
                  <select
                    class="form-select"
                    value={toppltype}
                    onChange={(e) => {
                      settoppltype(e.target.value);
                    }}
                    aria-label="Default select example"
                  >
                    <option selected default hidden disabled value="">
                      TOP TYPE?
                    </option>
                    <option value="1">All</option>
                    <option value="2">Category wise</option>
                  </select>
                </div>
              )}
              {orderby2 == "4" && (
                <div className="popt3">
                  <select
                    class="form-select"
                    value={topnum}
                    onChange={(e) => {
                      settopnum(e.target.value);
                    }}
                    aria-label="Default select example"
                  >
                    <option selected default hidden disabled value="">
                      TOP ?
                    </option>
                    <option value="1">Top 1</option>
                    <option value="2">Top 2</option>
                    <option value="3">Top 3</option>
                    <option value="4">Top 4</option>
                    <option value="5">Top 5</option>
                    <option value="6">Top 6</option>
                    <option value="7">Top 7</option>
                    <option value="8">Top 8</option>
                    <option value="9">Top 9</option>
                    <option value="10">Top 10</option>
                    <option value="11">Top 11</option>
                    <option value="12">Top 12</option>
                    <option value="15">Top 15</option>
                    <option value="20">Top 20</option>
                  </select>
                </div>
              )}
              {orderby2 == "4" && (
                <div className="popt3">
                  <select
                    class="form-select"
                    value={toptype}
                    onChange={(e) => {
                      settoptype(e.target.value);
                    }}
                    aria-label="Default select example"
                  >
                    <option selected default hidden disabled value="">
                      TOP Type
                    </option>
                    <option value="0">On single page</option>
                    <option value="1">Multiple</option>
                  </select>
                </div>
              )}

              {orderby2 !== "4" && orderby2 !== "6" && (
                <>
                  <div className="pdopt2">
                    <select
                      class="form-select"
                      value={orderby}
                      onChange={(e) => {
                        setorderby(e.target.value);
                      }}
                      aria-label="Default select example"
                    >
                      <option selected hidden default disabled value="">
                        Order By
                      </option>
                      {orderby2 == 1 && (
                        <>
                          <option value="1">Player Number</option>
                          <option value="2">PLayer Name</option>
                          <option value="3">Category</option>
                          <option value="4">Category-Namewise</option>
                        </>
                      )}
                      {orderby2 == 2 && (
                        <>
                          <option value="1">Player Number</option>
                          <option value="2">PLayer Name</option>
                        </>
                      )}
                      {orderby2 == 3 && (
                        <>
                          <option value="5">Sold sequence</option>
                          <option value="6">Category</option>
                          <option value="7">Value</option>
                          <option value="8">PLayer Name</option>
                        </>
                      )}
                    </select>
                  </div>
                  {orderby2 !== "4" && (
                    <div className="popt3">
                      <select
                        class="form-select"
                        value={pdflayouttype}
                        onChange={(e) => {
                          setpdflayouttype(e.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option selected default hidden disabled value="">
                          Layout Type
                        </option>
                        <option value="0">Type 1</option>
                        <option value="1">Type 2</option>
                      </select>
                    </div>
                  )}
                  {pdflayouttype == "0" && (
                    <div className="popt3">
                      <select
                        class="form-select"
                        value={colno}
                        onChange={(e) => {
                          setcolno(e.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option selected default hidden disabled value="">
                          column
                        </option>
                        <option value="2">Three</option>
                        <option value="1">Two</option>
                      </select>
                    </div>
                  )}
                  <div className="popt4">
                    {colno == 1 && (
                      <select
                        class="form-select"
                        value={numofpl}
                        onChange={(e) => {
                          setnumofpl(e.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option selected default hidden disabled value="">
                          Perpage Players
                        </option>
                        <option value={12}>First page-12/Rest-14</option>
                        <option value={14}>First page-14/Rest-16</option>
                        <option value={16}>First page-16/Rest-18</option>
                      </select>
                    )}
                    {colno == 2 && (
                      <select
                        class="form-select"
                        value={numofpl}
                        onChange={(e) => {
                          setnumofpl(e.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option selected default hidden disabled value="">
                          Perpage Players
                        </option>
                        <option value={24}>First page-24/Rest-30</option>
                        <option value={27}>First page-27/Rest-33</option>
                        <option value={30}>First page-30/Rest-36</option>
                        <option value={33}>First page-33/Rest-39</option>
                      </select>
                    )}
                  </div>{" "}
                </>
              )}
            </div>
            {orderby2 == "4" && (
              <>
                <div className="pdoptline2">
                  <div className="pdopt5">
                    <select
                      class="form-select"
                      value={ignoretype}
                      onChange={(e) => {
                        setignoretype(e.target.value);
                      }}
                      aria-label="Default select example"
                    >
                      <option selected hidden default disabled value="">
                        Want to ignore?
                      </option>
                      <option value="retain">Retain</option>
                      <option value="cat">Category</option>
                      <option value="tag">Tag</option>
                      <option value="plno">Player Number</option>
                      <option value="otag">Other Tag</option>
                      <option value="all tags">All Tags</option>
                    </select>
                  </div>
                  {ignoretype == "cat" && (
                    <div className="pdopt5">
                      <select
                        class="form-select"
                        value={ignorecat}
                        onChange={(e) => {
                          setignorecat(e.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option selected default value="">
                          select category
                        </option>
                        {catdata &&
                          catdata?.map((cat) => {
                            return (
                              <option value={cat.cid}>{cat.cname}</option>
                            );
                          })}
                      </select>
                    </div>
                  )}
                  {ignoretype == "tag" && (
                    <div className="pdopt5">
                      <select
                        class="form-select"
                        value={ignoretag}
                        onChange={(e) => {
                          setignoretag(e.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option selected hidden default disabled value="">
                          select Tag
                        </option>
                        <option value="0" selected>
                          Select tag
                        </option>
                        <option value="1">Owner</option>
                        <option value="2">Co-owner</option>
                        <option value="3">Captain</option>
                        <option value="4">Icon</option>
                        <option value="5">Retain</option>
                      </select>
                    </div>
                  )}
                </div>
                {ignoretype == "plno" && (
                  <div className="pdopt5">
                    <div>Comma separated player number. Ex: 25,50,30</div>

                    <input
                      type="text"
                      placeholder="Enter Player numbers"
                      value={ignoreplnos}
                      onChange={(e) => setignoreplnos(e.target.value)}
                    />
                  </div>
                )}
              </>
            )}
            {orderby2 != "4" && orderby2 != "6" && (
              <>
                <div className="pdoptline2">
                  <div className="pdopt5">
                    <select
                      class="form-select"
                      value={sts}
                      onChange={(e) => {
                        setsts(e.target.value);
                      }}
                      aria-label="Default select example"
                    >
                      <option selected hidden default disabled value="">
                        status
                      </option>
                      <option value="1">ALL</option>
                      <option value="2">Available</option>
                      <option value="3">Sold</option>
                      <option value="4">Unsold</option>
                      <option value="5">Unsold + available</option>
                      <option value="6">Available + unsold</option>
                    </select>
                  </div>

                  {/* <div> */}
                  {pdflayouttype != "1" && (
                    <div className="setdataopt">
                      <button className="setdata" onClick={setdata}>
                        Manage more data
                      </button>
                    </div>
                  )}
                </div>
                <div className="pdoptline2">
                  {issetdata && (
                    <>
                      <div className="showopt">
                        <div className="showoptline">
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setisplnoshow(e.target.checked)
                              }
                              checked={isplnoshow}
                              id="flexCheckDefault1"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault1"
                            >
                              Show player Number
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setispointsshow(e.target.checked)
                              }
                              checked={ispointsshow}
                              id="flexCheckDefault2"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault2"
                            >
                              Show points
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setiscatshow(e.target.checked)
                              }
                              checked={iscatshow}
                              id="flexCheckDefault5"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault5"
                            >
                              Show category
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setisspnshow(e.target.checked)
                              }
                              checked={isspnshow}
                              id="flexCheckDefault6"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault6"
                            >
                              Show Sponsor
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setisnocatshow(e.target.checked)
                              }
                              checked={isnocatshow}
                              id="flexCheckDefault66"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault66"
                            >
                              Show No category
                            </label>
                          </div>
                        </div>
                        <div className="showoptline">
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setismobnoshow(e.target.checked)
                              }
                              checked={ismobnoshow}
                              id="flexCheckDefault3"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault3"
                            >
                              Show mobile Number
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setistshirtshow(e.target.checked)
                              }
                              checked={istshirtshow}
                              id="flexCheckDefault4"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault4"
                            >
                              Show Tshirt size
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setisbasePriceShow(e.target.checked)
                              }
                              checked={isbasePriceShow}
                              id="flexCheckDefault11"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault11"
                            >
                              Show Base price
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setisvalshow(e.target.checked)
                              }
                              checked={isvalshow}
                              id="flexCheckDefault10"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault10"
                            >
                              Show value
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setisfathershow(e.target.checked)
                              }
                              checked={isfathershow}
                              id="flexCheckDefaultFather"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefaultFather"
                            >
                              Show father name
                            </label>
                          </div>
                        </div>
                        <div className="showoptline">
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) => setisspec1(e.target.checked)}
                              checked={isspec1}
                              id="flexCheckDefault7"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault7"
                            >
                              Show spec_1
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) => setisspec2(e.target.checked)}
                              checked={isspec2}
                              id="flexCheckDefault8"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault8"
                            >
                              Show spec_2
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) => setisspec3(e.target.checked)}
                              checked={isspec3}
                              id="flexCheckDefault9"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault9"
                            >
                              Show spec_3
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setisownershow(e.target.checked)
                              }
                              checked={isownershow}
                              id="flexCheckDefault13"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault13"
                            >
                              Show owner
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) =>
                                setisdetailshow(e.target.checked)
                              }
                              checked={isdetailshow}
                              id="flexCheckDefault14"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault14"
                            >
                              Show detail
                            </label>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            {orderby2 == "6" && (
              <>
                <div className="tagoptioncontainer">
                  <div>
                    <input
                      type="checkbox"
                      id="ownertag"
                      checked={isownertagselect}
                      onChange={(e) =>
                        setisownertagselect(e.target.checked)
                      }
                    />
                    <label htmlFor="ownertag">Owner</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="co-owner"
                      checked={iscoownertagselect}
                      onChange={(e) =>
                        setiscoownertagselect(e.target.checked)
                      }
                    />
                    <label htmlFor="co-owner">Co-Owner</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="captain"
                      checked={iscaptaintagselect}
                      onChange={(e) =>
                        setiscaptaintagselect(e.target.checked)
                      }
                    />
                    <label htmlFor="captain">Captain</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="vicecaptain"
                      checked={isvicecaptaintagselect}
                      onChange={(e) =>
                        setisvicecaptaintagselect(e.target.checked)
                      }
                    />
                    <label htmlFor="vicecaptain">Vice Captain</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="icon"
                      checked={isicontagselect}
                      onChange={(e) => setisicontagselect(e.target.checked)}
                    />
                    <label htmlFor="icon">Icon</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="retain"
                      checked={isretaintagselect}
                      onChange={(e) =>
                        setisretaintagselect(e.target.checked)
                      }
                    />
                    <label htmlFor="retain">Retain</label>
                  </div>
                </div>
              </>
            )}

            <div className="pdf-popup-actions">
              <button className="btn btn-primary pdclose" onClick={handleClose}>
                Close
              </button>
              <button
                className="btn btn-primary pddwn"
                onClick={handleDownload}
                disabled={isGenerating}
              >
                {isGenerating ? "Preparing..." : "Download PDF"}
              </button>
            </div>
          </div>
          {pdflayouttype !== "" && orderby2 !== "4" && orderby2 !== "5" && (
            <div className="layoutdemodiv">
              LAYOUT
              <div>
                <img
                  src={pdflayouttype == "0" ? pdflayout1 : pdflayout2}
                  className="pdflayoutimg"
                  alt=""
                />
              </div>
            </div>
          )}
        </div>
      </>
    </>
  );
}
